import Immutable, {Map} from 'immutable';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as CouponRateActions from 'actions/CouponRate';
import * as MakeBetActions from 'actions/MakeBet';
import * as BettingModeActions from 'actions/BettingMode';
import * as SignoutActions from 'actions/auth/SignoutAction';
import * as StorageActions from 'actions/Storage';
import * as BettingState from 'constants/BettingState';

const initialState = new Map();

export default function betSlipsReducer(betSlips, action) {
    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            const storedBetSlips = action.data.betSlips;
            if (storedBetSlips !== undefined && storedBetSlips !== null) {
                storedBetSlips.forEach(slip => {
                    const addRate = {
                        match: slip.get('match'),
                        outcome: slip.get('outcome'),
                        score: slip.get('score'),
                        rate: slip.get('rate')
                    };

                    betSlips = addCouponBetSlip(betSlips, addRate);
                });

                return betSlips;
            }
            break;

        case SignoutActions.SUCCESS_SIGNOUT:
            return initialState;

        case LIVE_UPDATE.SUCCESS:
            return update(betSlips, action.data);

        case CouponRateActions.ADD_COUPON_RATE:
            return addCouponBetSlip(betSlips, action.data);

        case CouponRateActions.REMOVE_COUPON_RATE:
            return removeCouponBetSlip(betSlips, action.data);

        case CouponRateActions.REMOVE_COUPON_RATES:
            return initialState;

        /*case MakeBetActions.MAKE_BET:
            return initialState;*/

        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;
            let rateBlockNum = 0;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
                        rateBlockNum++;
                        betSlips = applyRateChanges(betSlips, createdBet.factors);
                    }
                    if(createdBet.error === -18){
                        rateBlockNum++;
                    }
                }
            }

            return (rateBlockNum === 0) ? initialState : betSlips;

        case MakeBetActions.FAILURE_MAKE_BET:
        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
            return initialState;

        case CouponRateActions.ACCEPT_RATE_VALUE_CHANGE:
            return acceptRateValueChange(betSlips, action.data);
    }

    return betSlips;
}

function update(betSlips, data) {
    if (data.sports !== undefined) {
        if (data.sports.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'sportId', 'isBlockedBySport', data.sports.add, false);
        }
        if (data.sports.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'sportId', 'isBlockedBySport', data.sports.remove, true);
        }
    }
    if (data.leagues !== undefined) {
        if (data.leagues.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'leagueId', 'isBlockedByLeague', data.leagues.add, false);
        }
        if (data.leagues.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'leagueId', 'isBlockedByLeague', data.leagues.remove, true);
        }
    }
    if (data.events !== undefined) {
        if (data.events.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.events.add, false);
        }
        if (data.events.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.events.remove, true);
        }
    }
    if (data.blocked_events !== undefined) {
        if (data.blocked_events.add !== undefined) {
            betSlips = updateBetSlipsBlock(
                betSlips,
                'matchId',
                'isBlockedByMatch',
                data.blocked_events.add,
                true,
                (e) => e
            );
        }
        if (data.blocked_events.remove !== undefined) {
            betSlips = updateBetSlipsBlock(
                betSlips,
                'matchId',
                'isBlockedByMatch',
                data.blocked_events.remove,
                false,
                (e) => e
            );
        }
    }
    if (data.groups !== undefined) {
        if (data.groups.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'groupId', 'isBlockedByGroup', data.groups.add, false);
        }
        if (data.groups.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'groupId', 'isBlockedByGroup', data.groups.remove, true);
        }
    }
    if (data.outcomes !== undefined) {
        if (data.outcomes.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.outcomes.add, false);
        }
        if (data.outcomes.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.outcomes.remove, true);
        }
    }
    if (data.blocked_outcomes !== undefined) {
        if (data.blocked_outcomes.add !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome',
                data.blocked_outcomes.add, true, (e) => e);
        }
        if (data.blocked_outcomes.remove !== undefined) {
            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome',
                data.blocked_outcomes.remove, false, (e) => e);
        }
    }
    if (data.rates !== undefined) {
        if (data.rates.add !== undefined) {
            betSlips = addRates(betSlips, data.rates.add);
        }
        if (data.rates.change !== undefined) {
            betSlips = changeRates(betSlips, data.rates.change);
        }
    }
    return betSlips;
}

function addCouponBetSlip(betSlips, addRate) {
    const match = addRate.match;
    const outcome = addRate.outcome;
    const score = addRate.score;
    const rate = addRate.rate;

    const rateId = rate.get('id');

    if (!betSlips.has(rateId)) {
        const value = Immutable.fromJS({
            rate,
            outcome: {
                name: outcome.get('name')
            },
            match: {
                timeAndZone: match.get('timeAndZone'),
                name: match.get('name'),
                notice: match.get('notice')
            },
            score: score ? {
                score1: score.get('score1'),
                score2: score.get('score2')
            } : undefined
        });

        betSlips = betSlips.set(rateId, value);
    }

    return betSlips;
}

function removeCouponBetSlip(betSlips, removeCouponRate) {
    const rateId = removeCouponRate.rateId;

    betSlips = betSlips.delete(rateId);

    return betSlips;
}

function addRates(betSlips, addRates) {
    for (let i = 0; i < addRates.length; i++) {
        const rateId = addRates[i].id;

        if (!betSlips.has(rateId)) {
            continue;
        }

        betSlips = betSlips.updateIn([rateId, 'rate', 'isBlocked'], () => false);
    }

    return betSlips;
}

function changeRates(betSlips, changeRates) {
    if (changeRates === undefined) {
        return betSlips;
    }

    for (let rateId in changeRates) {
        if (!changeRates.hasOwnProperty(rateId)) {
            continue;
        }

        if (!betSlips.has(parseInt(rateId))) {
            continue;
        }

        const rateValue = changeRates[rateId];
        rateId = parseInt(rateId);

        betSlips = betSlips.update(rateId, (bs) => {
            bs = bs.update('rate', (r) => r.update('isBlocked', () => r.get('value') !== rateValue));

            return bs.update('rate', (r) => r.update('actualValue', () => rateValue));
        });
    }

    return betSlips;
}

function acceptRateValueChange(betSlips, ratesChanged) {
    for (let i = 0; i < ratesChanged.length; i++) {
        const rateChanged = ratesChanged[i];

        betSlips = betSlips.update(rateChanged.id, (bs) => {
            bs = bs.update('rate', (r) => r.update('isBlocked', () => false));
            return bs.update('rate', (r) => r.update('value', () => rateChanged.actualValue));
        });
    }

    return betSlips;
}

function updateBetSlipsBlock(betSlips, field, blockField, values, isBlocked, valueFunc) {
    for (let i = 0; i < values.length; i++) {
        const id = typeof(valueFunc) === 'function' ? valueFunc(values[i]) : values[i].id;

        const affectedBetSlips = getAffectedBetSlips(betSlips, field, id);

        affectedBetSlips.forEach((bs) => {
            const rateId = bs.getIn(['rate', 'id']);

            betSlips = betSlips.updateIn([rateId, 'rate', blockField], () => isBlocked);
        });
    }

    return betSlips;
}

function getAffectedBetSlips(betSlips, field, value) {
    return betSlips.filter((bs) => {
        if (bs.getIn(['rate', field]) === value) {
            return bs;
        }
    });
}

function applyRateChanges(betSlips, factors) {
    if (factors !== undefined && factors.length > 0) {
        for (let offset = 0; offset < factors.length; offset++) {
            const rateId = factors[offset].FactorId;
            const state = factors[offset].BettingState;
            const value = factors[offset].InitialValue;
            const actualValue = factors[offset].Value;

            const isChangedFactor = (
                state == BettingState.FACTOR_CHANGED ||
                (state == BettingState.CORRECT && value !== actualValue)
            );

            const isClosedOutcome = (
                state == BettingState.FACTOR_CLOSED || state == BettingState.OUTCOME_CLOSED
            );

            const isClosedEvent = (state == BettingState.EVENT_CLOSED);

            if (isChangedFactor) {
                betSlips = betSlips.setIn([rateId, 'rate', 'isBlocked'], true);
                if(actualValue > 0){
                    betSlips = betSlips.setIn([rateId, 'rate', 'actualValue'], actualValue);
                }
            } else if (isClosedOutcome) {
                betSlips = betSlips.setIn([rateId, 'rate', 'isBlockedByOutcome'], true);
            } else if (isClosedEvent) {
                betSlips = betSlips.setIn([rateId, 'rate', 'isBlockedByMatch'], true);
            }
        }
    }

    return betSlips;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/betSlipsReducer.js